import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../base";
import { Product } from "../products/product";
import { WorkItemProcess } from "./work-item-process";
export const WorkOrderItem = types
  .compose(
    Base,
    types.model({
      productId: types.maybeNull(types.string),
      product: types.maybeNull(Product),
      processes: types.array(WorkItemProcess),
      amount: types.maybeNull(types.number),
      productionAmount: types.maybeNull(types.number),
      finishedAmount: types.maybeNull(types.number),
      wastageAmount: types.maybeNull(types.number),
      foilDate: types.maybeNull(types.string),
      foilAmount: types.maybeNull(types.number),
      otherHandleDate: types.maybeNull(types.string),
      otherHandleAmount: types.maybeNull(types.number),
      shapeDate: types.maybeNull(types.string),
      shapeAmount: types.maybeNull(types.number),
      cutDate: types.maybeNull(types.string),
      cutAmount: types.maybeNull(types.number),
      pasteDate: types.maybeNull(types.string),
      pasteAmount: types.maybeNull(types.number),
      packageDate: types.maybeNull(types.string),
      packageAmount: types.maybeNull(types.number),
      printDate: types.maybeNull(types.string),
      printAmount: types.maybeNull(types.number),
      note: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IWorkOrderItem extends Instance<typeof WorkOrderItem> {}
export interface IWorkOrderItemProperties
  extends SnapshotIn<typeof WorkOrderItem> {}

export interface IAddWorkOrderItem
  extends Pick<
    IWorkOrderItemProperties,
    | "productId"
    | "amount"
    | "productionAmount"
    | "finishedAmount"
    | "wastageAmount"
    | "note"
  > {}

export interface IUpdateWorkOrderItem
  extends Pick<
    IWorkOrderItemProperties,
    | "id"
    | "productId"
    | "amount"
    | "productionAmount"
    | "finishedAmount"
    | "wastageAmount"
    | "note"
  > {}

export interface IUpdateDepartmentProcessItem {
  type: number;
  date: string;
  amount: number;
}
